<template>
  <div v-if="hasToken" class="home-map">
    <v-header></v-header>
    <el-row style="height:calc(100% - 65px)">
      <el-col :span="5" style="display:inline-block;height:100%">
        <div class="page-panel" style="margin-top:6px;">
          <div class="image-border image-border1"></div>
          <div class="image-border image-border2"></div>
          <div class="image-border image-border3"></div>
          <div class="image-border image-border4"></div>
          <div class="chart-wrapper" style="height:220px">
            <v-pie-chart :chart-data="total" :chart-title="'充电桩总数'" :height="'100%'"></v-pie-chart>
          </div>
          <el-form label-width="50%" class="data-form">
            <el-form-item label="总收益">
              <span>{{totalData.inCome == null ? 0:totalData.inCome}}</span>
              <span class="unit-label">元</span>
            </el-form-item>
            <el-form-item label="累计充电次数">
              <span>{{totalData.chargeNum == null ? 0:totalData.chargeNum}}</span>
              <span class="unit-label">次</span>
            </el-form-item>
            <el-form-item label="累计电量">
              <span>{{totalData.elecNum == null ? 0:totalData.elecNum}}</span>
              <span class="unit-label">度</span>
            </el-form-item>
            <el-form-item label="当前收益">
              <span>{{totalData.currentIncome == null ? 0:totalData.currentIncome}}</span>
              <span class="unit-label">元</span>
            </el-form-item>
          </el-form>
        </div>
        <div class="page-panel" style="height:calc(100% - 430px)">
          <div class="image-border image-border1"></div>
          <div class="image-border image-border2"></div>
          <div class="image-border image-border3"></div>
          <div class="image-border image-border4"></div>
          <div class="chart-wrapper" style="height:50%">
            <v-line-chart v-if="!totalLoading" :chart-data="totalIncome" :chart-title="'总收益'" :height="'100%'" :mode="'quadraticOut'"></v-line-chart>
          </div>
          <div class="chart-wrapper" style="height:50%">
            <v-line-chart v-if="!totalLoading" :chart-data="totalParking" :chart-title="'累计总电量'" :height="'100%'"></v-line-chart>
          </div>
        </div>
      </el-col>
      <el-col :span="14" style="height:100%">
        <div class="chart-wrapper" style="height:70%;padding-top:6px;">
          <v-map-chart :chart-data="converData(mapData)" :height="'100%'" @parkChange='handleParkChange'></v-map-chart>
        </div>
        <el-row style="height:calc(30% - 20px);" class="page-panel">
          <div class="image-border image-border1"></div>
          <div class="image-border image-border2"></div>
          <div class="image-border image-border3"></div>
          <div class="image-border image-border4"></div>
          <el-col :span="12" style="height:100%">
            <div class="chart-wrapper" style="height:100%">
              <v-line-chart v-if="currentVisible&&!singleLoading" :chart-data="singleIncome" :location="currentPark.name" :chart-title="'收益'" :height="'100%'" :mode="'quadraticOut'"></v-line-chart>
            </div>
          </el-col>
          <el-col :span="12" style="height:100%">
            <div class="chart-wrapper" style="height:100%">
              <v-line-chart v-if="currentVisible&&!singleLoading" :chart-data="singleParking" :location="currentPark.name" :chart-title="'累计电量'" :height="'100%'"></v-line-chart>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="5" style="display:inline-block;height:100%">
        <div class="page-panel" style="margin-top:6px;">
          <div class="image-border image-border1"></div>
          <div class="image-border image-border2"></div>
          <div class="image-border image-border3"></div>
          <div class="image-border image-border4"></div>
          <div class="chart-wrapper" style="height:220px">
            <v-pie-chart v-if="currentVisible" :chart-data="single" :chart-title="currentPark.name" :height="'100%'"></v-pie-chart>
          </div>
          <el-form label-width="50%" class="data-form">
            <el-form-item label="总收益">
              <span>{{currentSingleData.inCome == null ? 0:currentSingleData.inCome}}</span>
              <span class="unit-label">元</span>
            </el-form-item>
            <el-form-item label="累计充电次数">
              <span>{{currentSingleData.chargeNum == null ? 0:currentSingleData.chargeNum}}</span>
              <span class="unit-label">次</span>
            </el-form-item>
            <el-form-item label="累计电量">
              <span>{{currentSingleData.elecNum == null ? 0:currentSingleData.elecNum}}</span>
              <span class="unit-label">度</span>
            </el-form-item>
            <el-form-item label="当前收益">
              <span>{{currentSingleData.currentIncome == null ? 0:currentSingleData.currentIncome}}</span>
              <span class="unit-label">元</span>
            </el-form-item>
          </el-form>
        </div>
        <div class="status-panel page-panel">
          <div class="image-border image-border1"></div>
          <div class="image-border image-border2"></div>
          <div class="image-border image-border3"></div>
          <div class="image-border image-border4"></div>
          <div style="width:100%;padding:10px;">
            <span class="status-label">状态</span>
            <i :class="currentSingleData.status ? 'icon iconfont icon-guzhang fault':'icon iconfont icon-zhengchang'"></i>
          </div>
          <div style="width:100%;padding:10px;">
            <span class="status-label">故障</span>
            <span style="font-size:22px">{{currentSingleData.status?currentSingleData.fault:'无'}}</span>
          </div>
          <div v-loading="!voiceLoaded" class="media-container" id="ui-talk">
            <div id="video-container" style="width:100%;height:100%"></div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* global EZUIKit , $config */
import axios from 'axios'
import { getToken } from '../../utils/auth'
import { getparkList, getCharageStatus } from '../../api/parkInfo' // getparkNum, getparkIncome
import vHeader from './Header.vue'
import vPieChart from './PieChart'
import vLineChart from './LineChart'
import vMapChart from './mapChart'
import {getMonitorInfo} from '../../api/monitorInfo'
import {getStatisticsInfo, getStatisticsInfo1day, getInfo7days} from '../../api/lcChargerLog'
export default {
  name: 'home',
  data () {
    return {
      hasToken: false,
      // totalParkNum: {},
      // singleParkNum: {},
      totalNum: {},
      totalDayNum: {},
      totalSevenDaysNum: [],
      singleNum: {},
      singleDayNum: {},
      singleSevenDaysNum: [],
      totalLoading: false,
      totalIncome: [],
      totalParking: [],
      totalParkIncome: {},
      singleLoading: false,
      singleIncome: [],
      singleParking: [],
      singleParkIncome: {},
      currentPark: {},
      currentVisible: false,
      mapData: [],
      playerInstance: null,
      ezuikitTalkData: {},
      voiceLoaded: false,
      voiceWidth: '',
      voiceHeight: '',
      parkfieldId: '',
      minitorInfo: {}
    }
  },
  components: { vHeader, vPieChart, vLineChart, vMapChart }, // , vVoice
  mounted: function () {
    if (!localStorage.accessToken || localStorage.accessToken === '' || typeof localStorage.accessToken === 'undefined') {
      this.getAccessToken()
    }
    this.$nextTick(function () {
      if (!getToken()) {
        this.hasToken = false
        this.$commons.toLogin()
      } else {
        this.hasToken = true
        this.getParkInfo()
        this.$nextTick(function () {

        })
      }
    })
  },
  computed: {
    total: function () {
      var data = []
      // data.push({ value: this.totalParkNum['bigSpaceTotal'], name: '使用' })
      // data.push({ value: this.totalParkNum['smallSpaceTotal'], name: '空闲' })
      data.push({ value: this.totalNum['usedCharger'], name: '占用' })
      data.push({ value: this.totalNum['freeCharger'], name: '空闲' })
      return data
    },
    totalData: function () {
      var data = {}
      // data.income = this.totalParkNum['feeTotal']
      // data.currentIncome = this.totalParkNum['feeCurrent']
      // data.todayParking = this.totalParkNum['parknumTotal']
      // data.remain = this.totalParkNum['bigSpaceRemaining'] + this.totalParkNum['smallSpaceRemaining']
      data.inCome = this.totalNum['inCome']
      data.chargeNum = this.totalNum['chargeNum']
      data.elecNum = this.totalNum['elecNum']
      data.currentIncome = this.totalDayNum['inCome']
      return data
    },
    single: function () {
      var data = []
      // data.push({ value: this.singleParkNum['bigSpaceTotal'], name: '使用' })
      // data.push({ value: this.singleParkNum['smallSpaceTotal'], name: '空闲' })
      data.push({ value: this.singleNum['usedCharger'], name: '占用' })
      data.push({ value: this.singleNum['freeCharger'], name: '空闲' })
      return data
    },
    currentSingleData: function () {
      []
      var data = {}
      // data.currentIncome = this.singleParkNum['feeCurrent']
      // data.todayParking = this.singleParkNum['parknumTotal']
      // data.remain = {
      //   small: this.singleParkNum['smallSpaceRemaining'],
      //   large: this.singleParkNum['bigSpaceRemaining']
      // }
      // data.status = this.singleParkNum['parkStatus'] ? 1 : 0
      // data.fault = this.singleParkNum['parkStatus'] ? this.singleParkNum['parkStatus'] : '无'
      data.inCome = this.singleNum['inCome']
      data.chargeNum = this.singleNum['chargeNum']
      data.elecNum = this.singleNum['elecNum']
      data.currentIncome = this.singleDayNum['inCome']
      return data
    }
  },
  methods: {
    converData (data) {
      console.log(data)
      var res = []
      for (var i = 0; i < data.length; i++) {
        res.push({
          name: data[i].name,
          value: [data[i].longitude, data[i].latitude, data[i]['id']]
        })
      }
      return res
    },
    handleParkChange (index, id) {
      console.log('handleParkChange:' + id)
      if (id) {
        if (this.currentPark.id !== id) {
          this.currentPark = this.mapData[index]
          // this.updateParkNum()
          // this.updateParkIncome()
          this.getStatisticsInfo(id)
          this.getStatisticsInfo1day(id)
          this.getInfo7days(id)
          // document.getElementById('ui-talk').innerHTML = ''
          document.getElementById('video-container').remove()
          var containerDiv = document.createElement('div')
          containerDiv.id = 'video-container'
          containerDiv.style.width = '100%'
          containerDiv.style.height = '100%'
          document.getElementById('ui-talk').appendChild(containerDiv)
          this.play(id)
        }
      }
    },
    // initPlayer () {
    //   this.voiceWidth = document.getElementById('ui-talk').clientWidth
    //   this.voiceHeight = document.getElementById('ui-talk').clientHeight
    //   this.playerInstance = new EZUIKit.EZUIKitPlayer({
    //     autoplay: true,
    //     id: 'video-container',
    //     accessToken: localStorage.accessToken,
    //     url: '',
    //     template: 'voice', // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版；
    //     width: this.voiceWidth,
    //     height: this.voiceWidth * 9 / 16
    //   })
    //   this.voiceLoaded = true
    // },
    initTalkPlayer (id) {
      console.log('initTalkPlayer')
      console.log(this.minitorInfo)
      var url
      url = this.minitorInfo.url
      console.log(url)
      console.log(localStorage.accessToken)
      this.voiceWidth = document.getElementById('ui-talk').clientWidth
      this.voiceHeight = document.getElementById('ui-talk').clientHeight
      this.playerInstance = new EZUIKit.EZUIKitPlayer({
        autoplay: true,
        id: 'video-container',
        accessToken: localStorage.accessToken,
        url: url,
        template: 'voice', // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版；
        width: this.voiceWidth,
        height: this.voiceWidth * 9 / 16
      })
      this.voiceLoaded = true
    },
    play (id) {
      var params = new FormData()
      if (id) {
        console.log(id)
        getMonitorInfo(id).then(resp => {
          if (resp.errmsg === 'ok') {
            this.minitorInfo = resp.data[0]
            params.append('accessToken', localStorage.accessToken)
            params.append('source', resp.data.source)
          }
        }).catch(e => {
          console.log(e)
        })
      } else {
        params.append('accessToken', localStorage.accessToken)
        params.append('source', $config.source)
      }
      axios.post('https://open.ys7.com/api/lapp/live/video/open', params, {
        timeout: 5000
      })
        .then(res => {
          if (res.data.code === '10002') {
            this.getAccessToken((id) => {
              this.play(id)
            })
          } else {
            this.getAddress(id)
            setTimeout(() => {
              // this.initPlayer()
              this.initTalkPlayer(id)
            }, 2500)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    getAccessToken (id, callback) {
      callback = callback || function () { }
      var params = new FormData()
      getMonitorInfo(id).then(resp => {
        if (resp.errmsg === 'ok') {
          this.minitorInfo = resp.data[0]
          params.append('appKey', resp.data[0].appkey)
          params.append('appSecret', resp.data[0].secret)
        }
        console.log(resp)
        console.log(this.minitorInfo)
        console.log(resp.data[0].appkey)
        console.log(resp.data[0].secret)
        console.log(this.$route.params)
        return axios.post('https://open.ys7.com/api/lapp/token/get', params, {
          timeout: 5000
        })
      })
      .then(res => {
        if (res.data) {
          console.log(res.data.data.accessToken)
          localStorage.setItem('accessToken', res.data.data.accessToken)
          callback()
        }
      })
      .catch(e => {
        console.log(e)
      })
    },
    getAddress (id) {
      var params = new FormData()
      getMonitorInfo(id).then(resp => {
        if (resp.errmsg === 'ok') {
          this.minitorInfo = resp.data[0]
          params.append('accessToken', localStorage.accessToken)
          params.append('source', resp.data.source)
        }
        return axios.post('https://open.ys7.com/api/lapp/live/address/get', params, {
          timeout: 5000
        })
      })
      .then(res => {
        console.log(res)
      })
      .catch(e => {
        console.log(e)
      })
    },
    closeChannel (callback) {
      callback = callback || function () { }
      var params = new FormData()
      params.append('accessToken', localStorage.accessToken)
      params.append('source', this.minitorInfo.source)
      return axios.post('https://open.ys7.com/api/lapp/live/video/close', params, {
        timeout: 5000
      })
      .then(res => {
        console.log(res)
        callback()
      })
      .catch(e => {
        console.log(e)
      })
    },
    handleRestart () {
      this.closeChannel(() => {
        this.$refs.voiceVideo.init()
      })
    },
    getParkInfo () {
      getparkList().then(resp => {
        if (resp.errmsg === 'ok') {
          this.getStatisticsInfo(this.parkfieldId)
          this.getStatisticsInfo1day(this.parkfieldId)
          this.getInfo7days(this.parkfieldId)
          this.getCharageStatus(this.parkfieldId)
          this.mapData = resp.data
          console.log(this.mapData)
          console.log(this.mapData[0].id)
          this.parkfieldId = this.mapData[0].id
          console.log(this.parkfieldId)
          console.log(this.currentPark)
          this.getStatisticsInfo(this.parkfieldId)
          this.getStatisticsInfo1day(this.parkfieldId)
          this.getInfo7days(this.parkfieldId)
          this.getCharageStatus(this.parkfieldId)
          this.getAccessToken(this.parkfieldId)
          this.play(this.parkfieldId)
          this.currentPark = this.mapData[0]
          this.currentVisible = true
        }
      }).catch(e => {
        console.log(e)
      })
    },
    getStatisticsInfo (parkfieldId) { // 实时历史数据更新
      getStatisticsInfo(parkfieldId).then(resp => {
        if (resp.errmsg === 'ok') {
          if (parkfieldId == null || parkfieldId === '') {
            this.totalNum = resp.data
          } else {
            this.singleNum = resp.data
          }
          console.log('totalNum:' + JSON.stringify(this.totalNum))
          console.log('singleNum:' + JSON.stringify(this.singleNum))
        }
      })
    },
    getStatisticsInfo1day (parkfieldId) { // 实时当天数据更新
      getStatisticsInfo1day(parkfieldId).then(resp => {
        if (resp.errmsg === 'ok') {
          if (parkfieldId == null || parkfieldId === '') {
            this.totalDayNum = resp.data
          } else {
            this.singleDayNum = resp.data
          }
          console.log('totalDayNum:' + JSON.stringify(this.totalDayNum))
          console.log('singleDayNum:' + JSON.stringify(this.singleDayNum))
        }
      })
    },
    getInfo7days (parkfieldId) { // 获取7天统计数据信息
      getInfo7days(parkfieldId).then(resp => {
        if (resp.errmsg === 'ok') {
          if (parkfieldId == null || parkfieldId === '') {
            this.totalSevenDaysNum = resp.data
            for (var i = 0; i < this.totalSevenDaysNum.length; i++) {
              this.totalIncome.push(this.totalSevenDaysNum[i].inCome == null ? 0 : this.totalSevenDaysNum[i].inCome)
            }
            for (i = 0; i < this.totalSevenDaysNum.length; i++) {
              this.totalParking.push(this.totalSevenDaysNum[i].elecNum == null ? 0 : this.totalSevenDaysNum[i].elecNum)
            }
          } else {
            this.singleSevenDaysNum = resp.data
            for (i = 0; i < this.singleSevenDaysNum.length; i++) {
              this.singleIncome.push(this.singleSevenDaysNum[i].inCome == null ? 0 : this.singleSevenDaysNum[i].inCome)
            }
            for (i = 0; i < this.singleSevenDaysNum.length; i++) {
              this.singleParking.push(this.singleSevenDaysNum[i].elecNum == null ? 0 : this.singleSevenDaysNum[i].elecNum)
            }
          }
          console.log('singleSevenDaysNum:' + JSON.stringify(this.totalSevenDaysNum))
          console.log('singleDayNum:' + JSON.stringify(this.singleSevenDaysNum))
          console.log('totalIncome:' + JSON.stringify(this.totalIncome))
          console.log('totalParking:' + JSON.stringify(this.totalParking))
          console.log('singleIncome:' + JSON.stringify(this.singleIncome))
          console.log('singleParking:' + JSON.stringify(this.singleParking))
        }
      })
    },
    getCharageStatus (parkfieldId) { // 空闲，使用
      getCharageStatus(parkfieldId).then(resp => {
        if (resp.errmsg === 'ok') {
          if (parkfieldId == null || parkfieldId === '') {
            this.totalNum.usedCharger = resp.data.usedCharger
            this.totalNum.freeCharger = resp.data.freeCharger
          } else {
            this.singleNum.usedCharger = resp.data.usedCharger
            this.singleNum.freeCharger = resp.data.freeCharger
          }
          console.log('freeCharger:' + JSON.stringify(this.totalNum.freeCharger))
          console.log('usedCharger:' + JSON.stringify(this.totalNum.usedCharger))
          console.log('freeCharger:' + JSON.stringify(this.singleNum.freeCharger))
          console.log('usedCharger:' + JSON.stringify(this.singleNum.usedCharger))
        }
      })
    }
    // startUpdateParkNum () {
    //   setTimeout(() => {
    //     this.updateParkNum(() => {
    //       this.startUpdateParkNum()
    //     })
    //   }, 60000)
    // },
    // updateParkNum (callback) {
    //   callback = callback || function () { }
    //   getparkNum(0).then(resp => {
    //     if (resp.errmsg === 'ok') {
    //       this.totalParkNum = resp.data[0]
    //     }
    //     return getparkNum(this.currentPark.id)
    //   })
    //     .then(resp => {
    //       console.log(resp)
    //       if (resp.errmsg === 'ok') {
    //         this.singleParkNum = resp.data[0]
    //       }
    //       callback()
    //     })
    //     .catch(e => {
    //       console.log(e)
    //       callback()
    //     })
    // },
    // startUpdateParkIncome () {
    //   var date = new Date()
    //   var timeStamp = new Date(new Date().setHours(0, 0, 0, 0) + 86400 * 1000)
    //   var timer = timeStamp - date
    //   setTimeout(() => {
    //     this.updateParkIncome(() => {
    //       this.startUpdateParkIncome()
    //     })
    //   }, timer)
    // },
    // updateParkIncome (callback) {
    //   callback = callback || function () { }
    //   this.totalLoading = true
    //   this.singleLoading = true
    //   getparkIncome(0).then(resp => {
    //     if (resp.errmsg === 'ok') {
    //       this.totalParkIncome = resp.data[0]
    //       this.totalIncome = this.totalParkIncome['parkIncome'].split(',')
    //       this.totalParking = this.totalParkIncome['parkNum'].split(',')
    //       this.totalLoading = false
    //     }
    //     return getparkIncome(this.currentPark.id)
    //   })
    //     .then(resp => {
    //       if (resp.errmsg === 'ok') {
    //         this.singleParkIncome = resp.data[0]
    //         this.singleIncome = this.singleParkIncome['parkIncome'].split(',')
    //         this.singleParking = this.singleParkIncome['parkNum'].split(',')
    //         this.singleLoading = false
    //       }
    //       callback()
    //     })
    //     .catch(e => {
    //       this.totalLoading = false
    //       this.singleLoading = false
    //       callback()
    //       console.log(e)
    //     })
    // }
  },
  deactivated () {
    this.closeChannel()
  },
  beforeDestroy () {
    this.closeChannel()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
$bg: #283443;
$light_gray: #fff;
$cursor: #fff;
.home-map {
  background-color: $bg;
  width: 100%;
  height: 100%;
  color: $light_gray;
  .chart-wrapper {
    background: transparent;
    padding: 16px 16px 0;
  }
  .el-form-item {
    margin-bottom: 5px;
  }
  .el-form-item__label {
    font-size: 18px;
  }
  .el-form-item__content {
    text-align: center;
    font-size: 24px;
    color: #409eff;
    font-weight: bold;
  }
  .unit-label {
    margin-right: 50px;
    float: right;
    font-size: 18px;
    color: #666;
  }
  .status-panel {
    height: calc(100% - 473px);
    .status-label {
      color: #ccc;
      font-size: 24px;
      font-weight: bold;
      width: 50%;
      margin: 20px;
    }
    i {
      font-size: 50px;
      width: 50%;
      color: #67c23a;
    }
    .fault {
      color: #f56c6c;
    }
  }
  .page-panel {
    border: 1px dashed rgba(64, 158, 255, 0.3);
    margin: 10px;
    position: relative;
    width: calc(100% -20px);
    background-color: rgba(64, 158, 255, 0.1);
    .image-border {
      position: absolute;
      width: 20px;
      height: 20px;
    }

    .image-border1 {
      top: 0;
      left: 0;
      border-left: 3px solid rgba(64, 158, 255, 0.7);
      border-top: 3px solid rgba(64, 158, 255, 0.7);
    }

    .image-border2 {
      top: 0;
      right: -2px;
      border-right: 3px solid rgba(64, 158, 255, 0.7);
      border-top: 3px solid rgba(64, 158, 255, 0.7);
    }

    .image-border3 {
      bottom: 0;
      left: 0;
      border-bottom: 3px solid rgba(64, 158, 255, 0.7);
      border-left: 3px solid rgba(64, 158, 255, 0.7);
    }

    .image-border4 {
      bottom: 0;
      right: -2px;
      border-right: 3px solid rgba(64, 158, 255, 0.7);
      border-bottom: 3px solid rgba(64, 158, 255, 0.7);
    }
  }
  .media-container {
    height: 260px;
    width: 100%;

    #myPlayer {
      height: 240px;
      width: 100%;
    }
    #ui-talk {
      height: 100%;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/Home.vue